// GENERATED FILE, PLEASE DO NOT EDIT
export var None = 0;
export var Small = 4;
export var Medium = 8;
export var Large = 16;
export var XLarge = 24;